var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1969_3508)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -9208.33,
    y: -6547,
    width: 21622,
    height: 22560.7,
    stroke: "#232323",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1969_3508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.88909 5.47739C3.84934 5.47739 4.62778 4.69895 4.62778 3.7387C4.62778 2.77844 3.84934 2 2.88909 2C1.92883 2 1.15039 2.77844 1.15039 3.7387C1.15039 4.69895 1.92883 5.47739 2.88909 5.47739Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10254 4.08984H17.8392",
    stroke: "#232323",
    strokeWidth: 2.37281,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.88909 11.7352C3.84934 11.7352 4.62778 10.9568 4.62778 9.99651C4.62778 9.03625 3.84934 8.25781 2.88909 8.25781C1.92883 8.25781 1.15039 9.03625 1.15039 9.99651C1.15039 10.9568 1.92883 11.7352 2.88909 11.7352Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10254 10.3555H17.8392",
    stroke: "#232323",
    strokeWidth: 2.37281,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.88909 18.0008C3.84934 18.0008 4.62778 17.2224 4.62778 16.2621C4.62778 15.3019 3.84934 14.5234 2.88909 14.5234C1.92883 14.5234 1.15039 15.3019 1.15039 16.2621C1.15039 17.2224 1.92883 18.0008 2.88909 18.0008Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10254 16.6133H17.8392",
    stroke: "#232323",
    strokeWidth: 2.37281,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1969_3508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1969_3508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.5d32ee646e435413806cfa4d5f30cfeb.svg";
export { ForwardRef as ReactComponent };